import type { ReactNode } from "react";

export function CalculatorCard({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-2xl border border-border bg-card p-6 shadow-sm md:p-8">
      {children}
    </div>
  );
}
